import { useMemo } from 'react';

import isEmpty from 'lodash/isEmpty';

import { useFlag } from '../../services/launchDarkly';

export interface ChaseMilestone {
  value: number;
  time?: string;
}

export interface ChaseBarConfig {
  startDate: string;
  completedDate: string;
  endDate: string;
  milestones: ChaseMilestone[];
}

const DEFAULT_CHASE_BAR_CONFIG: ChaseBarConfig = {
  startDate: '2026-04-24T10:00:00Z',
  completedDate: '2026-04-26T00:00:00Z',
  endDate: '2026-04-26T10:00:00Z',
  milestones: [{ value: 3158 }, { value: 6316 }],
};

export const TARGET_VALUE = 10_000;

const isConfigValid = (config: ChaseBarConfig): boolean => {
  return Boolean(
    !isEmpty(config) && config.startDate && config.completedDate && config.endDate && config.milestones?.length > 0,
  );
};

export function useChaseBarConfig(): ChaseBarConfig {
  const raw = useFlag<ChaseBarConfig>('chase_bar_config', DEFAULT_CHASE_BAR_CONFIG);
  const config = isConfigValid(raw) ? raw : DEFAULT_CHASE_BAR_CONFIG;

  const milestonesKey = config.milestones.map((m) => `${m.value}:${m.time ?? ''}`).join(',');

  return useMemo(
    () => config,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config.startDate, config.completedDate, config.endDate, milestonesKey],
  );
}
